import { FourOhFour } from 'components/four-oh-four';

const FourOhFourContainer = FourOhFour;

export { FourOhFourContainer };
